// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 9L12 2L20 9V21H15V9H9V21H4V9Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 21V9L12 2L20 9V21M4 21H3M4 21C8 21 5 21 9 21M20 21H21M20 21C20 21 16 21 14 21M9 9V21M9 9H15M9 9H4.75M9 21H10M15 9V21M15 9H19.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DamIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam',
    ref,
    icon: element,
  },
));

DamIcon.displayName = 'DamIcon';

export default DamIcon;
